export default {
  tasks: [],
  task: undefined,
};
